
import { Suspense } from 'react';
import LoadingSpinner from '../components/LoadingSpinner/LoadingSpinner';
import { getAllNavigationItems } from './navigation';

import Dashboard from "../components/Admin/Dashboard/Dashboard";

import MADiscoveryDashboard from "../components/MADiscovery/MADiscoveryDashboard";

import IndustryList from "../components/Admin/Industry/List";
import AddIndustry from "../components/Admin/Industry/Add";
import EditIndustry from "../components/Admin/Industry/Edit";

import CompanyList from "../components/Admin/Company/List";
import AddCompany from "../components/Admin/Company/Add";
import EditCompany from "../components/Admin/Company/Edit";

import MergeAndAcquisitionList from "../components/Admin/MergeAndAcquisition/List";
import AddMergeAndAcquisition from "../components/Admin/MergeAndAcquisition/Add";
import EditMergeAndAcquisition from "../components/Admin/MergeAndAcquisition/Edit";

import MAndATimelineGraph from "../components/Admin/Graphs/MAndATimelineGraph";
import NetworkGraph from "../components/Admin/Graphs/NetworkGraph";
import SankeyDiagram from "../components/Admin/Graphs/SankeyDiagram";

import AblationBenchmark from "../components/Admin/AblationStudy/AblationBenchmark";
import MAForecastGraph from "../components/Admin/MAForecast/MAForecastGraph";
import DataDistributionDashboard from "../components/Admin/DataDistribution/DataDistributionDashboard";
import MethodologyDiagram from "../components/Admin/Methodology/MethodologyDiagram";
import NvidiaAnalysis from "../components/NvidiaAnalysis/NvidiaAnalysis";
import QualcommAnalysis from "../components/QualcommAnalysis/QualcommAnalysis";
import WaveForecastDashboard from "../components/Admin/WaveForecasting/WaveForecastDashboard";
import NetworkMetricsDashboard from "../components/Admin/NetworkAnalysis/NetworkMetricsDashboard";
import MethodologyValidationDashboard from "../components/Admin/MethodologyValidation/MethodologyValidationDashboard";
import PaperData from "../components/Admin/PaperData/PaperData";
import PaperVisualizationDashboard from "../components/Admin/PaperVisualizations/PaperVisualizationDashboard";
import { ViabilityPredictionDashboard } from "../components/ViabilityPrediction";

const componentMap = {
  "/Dashboard": <Dashboard />,
  "/MADiscovery/Dashboard": <MADiscoveryDashboard />,
  "/Industry/List": <IndustryList />,
  "/Industry/Add": <AddIndustry />,
  "/Industry/Edit/:id": <EditIndustry />,
  "/Company/List": <CompanyList />,
  "/Company/Add": <AddCompany />,
  "/Company/Edit/:id": <EditCompany />,
  "/MergeAndAcquisition/List": <MergeAndAcquisitionList />,
  "/MergeAndAcquisition/Add": <AddMergeAndAcquisition />,
  "/MergeAndAcquisition/Edit/:id": <EditMergeAndAcquisition />,
  "/Graphs/MAndATimelineGraph": <MAndATimelineGraph />,
  "/Graphs/NetworkGraph": <NetworkGraph />,
  "/Graphs/SankeyDiagram": <SankeyDiagram />,
  "/DataDistribution/DataDistributionDashboard": <DataDistributionDashboard />,
  "/Methodology/MethodologyDiagram": <MethodologyDiagram />,
  "/AblationStudy/Benchmark": <AblationBenchmark />,
  "/MAForecast/MAForecastGraph": <MAForecastGraph />,
  "/nvidia-analysis": <NvidiaAnalysis />,
  "/qualcomm-analysis": <QualcommAnalysis />,
  "/WaveForecasting/Dashboard": <WaveForecastDashboard />,
  "/NetworkAnalysis/Dashboard": <NetworkMetricsDashboard />,
  "/MethodologyValidation/Dashboard": <MethodologyValidationDashboard />,
  "/PaperData/Dashboard": <PaperData />,
  "/PaperVisualizations/Dashboard": <PaperVisualizationDashboard />,
  "/ViabilityPrediction/Dashboard": <ViabilityPredictionDashboard />
};

const additionalRoutes = [
  { path: "/Industry/Add", element: <AddIndustry />, roles: ["admin"] },
  { path: "/Industry/Edit/:id", element: <EditIndustry />, roles: ["admin"] },
  { path: "/Company/Add", element: <AddCompany />, roles: ["admin"] },
  { path: "/Company/Edit/:id", element: <EditCompany />, roles: ["admin"] },
  { path: "/MergeAndAcquisition/Add", element: <AddMergeAndAcquisition />, roles: ["admin"] },
  { path: "/MergeAndAcquisition/Edit/:id", element: <EditMergeAndAcquisition />, roles: ["admin"] }
];

const generateMainRoutes = () => {
  const navigationItems = getAllNavigationItems();
  return navigationItems.map(item => ({
    path: item.path,
    element: componentMap[item.path],
    roles: item.roles,
    category: item.category
  }));
};

export const allRoutes = [
  ...generateMainRoutes(),
  ...additionalRoutes
];

export const getRoutesByRole = (userRole) => {
  return allRoutes.filter(route => route.roles.includes(userRole));
};

export const getRoutesByCategory = (category) => {
  return allRoutes.filter(route => route.category === category);
}; 